import PropTypes from 'prop-types'
import useAuth from '@/hooks/useAuth'
import BillingInactive from '@/pages/BillingInactive'

/**
 * Blocks a route when the active organisation's subscription is inactive.
 * Mirrors the `=== false` guard used in PowerExplore / the sidebar nav so a
 * missing/unknown flag leaves access open (fail-open).
 */
const BillingGuard = ({ children }) => {
    const { activeOrg } = useAuth()

    if (activeOrg?.is_billing_active === false) {
        return <BillingInactive />
    }

    return <>{children}</>
}

BillingGuard.propTypes = {
    children: PropTypes.node
}

export default BillingGuard
